import React from 'react';
import { cx } from './utils';

const Skeleton = ({ className = '' }) => (
  <div className={cx('animate-pulse rounded-xl bg-slate-200/70', className)} />
);

export default Skeleton;
